module.exports = __webpack_public_path__ + "static/media/orientation-to-horizontal.66742a0e.png";